var map = {
	"./video-carousel.de-CH.json": 1451,
	"./video-carousel.de-DE.json": 1452,
	"./video-carousel.en-CA.json": 1453,
	"./video-carousel.en-GB.json": 1454,
	"./video-carousel.en-IN.json": 1455,
	"./video-carousel.en-ME.json": 1456,
	"./video-carousel.en-US.json": 1457,
	"./video-carousel.es-EM.json": 1458,
	"./video-carousel.es-ES.json": 1459,
	"./video-carousel.fr-BE.json": 1460,
	"./video-carousel.fr-CA.json": 1461,
	"./video-carousel.fr-CH.json": 1462,
	"./video-carousel.nl-BE.json": 1463,
	"./video-carousel.nl-NL.json": 1464,
	"./video-carousel.pl-PL.json": 1465,
	"./video-carousel.pt-BR.json": 1466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1450;